<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        
        <b-card 
            id="item-quote-history-table-card"
            class="shadow rounded-lg animate__animated animate__fadeIn animate__fast"
            no-body
        >
            <div 
                v-if="!loadingList && !rfxList.length"
                class="text-center py-5 text-muted"
            >
                No History
            </div>

            <b-table 
                v-else
                :items="rfxList"
                :fields="fields"
                :busy="loadingList"
                primary-key="id" 
                hover
                class="no-top-border td-align-middle mb-0"
                thead-class="overflow-hidden cells-align-middle"
                head-variant="light"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-primary my-2">
                        <busy-spinner text="Loading..."></busy-spinner>
                    </div>
                </template>
                <template #cell(title)="data">
                    <b-link v-if="data.item.can_tu_view" key="tuCanView" :href="data.item.internal_manage_url" class="font-weight-bold">{{data.value}}</b-link>
                    <span v-else key="tuCannotView" class="font-weight-bold">{{data.value}}</span>
                    <b-badge 
                        v-if="!data.item.can_tu_view" 
                        v-b-tooltip.hover
                        title="You do not have access to the details of this RFx"
                        variant="soft-secondary" 
                        class="text-uppercase ml-2"
                    >No Access</b-badge>
                </template>
                <template #cell(created)="data">
                    {{ data.value | dateFilter }}
                </template>
                <template #cell(sm_state)="data">
                    <status-object-badge 
                        :status-object="data.item.state_dict" 
                        text-uppercase
                        font-size="0.8rem"
                    ></status-object-badge>
                </template>
            </b-table>
        </b-card>

        <!-- <h3>Rfx List</h3>
        <pre>{{ rfxList }}</pre> -->


    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
//import cloneDeep from 'lodash/cloneDeep';
import { FormatDateHelper, FormatDecimalHelper, FormatCurrencyHelper } from '../js/filters-helpers';
import StatusObjectBadge from './functional-comps/StatusObjectBadge';
import { Rfx } from '../js/models/rfx';

export default {
    name: 'ItemQuoteHistory',
    components: {
        StatusObjectBadge,
    },
    props: {
        itemId: {
            type: [String, Number],
            required: true,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingList: false,
            lineItemBids: [],  // stash data here from API
            rfxList: [],  // NEW - the list of RFX that this is on
            fields: [
                {
                    key: 'title',
                    label: 'Sourcing Event',
                    sortable: true,
                },
                {
                    key: 'rfx_type_display',
                    label: 'Event Type',
                    sortable: true,
                },
                {
                    key: 'sourcing_owner_name',
                    label: 'Event Owner',
                },
                {
                    key: 'sm_state',
                    label: 'Status',
                    sortable: true,
                },
                {
                    key: 'created',
                    label: 'Created Date',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: '',
                    tdClass: 'max-width-200 small',
                },
            ],
        }
    },
    computed: {

    },
    filters: {
        dateFilter: function(value) {
            return FormatDateHelper(value);
        },
        decimalFilter: function(value) {
            return FormatDecimalHelper(value);
        },
    },
    mounted: function() {
        this.getList();
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        getList: function() {
            this.loadingList = true;
            return suppliosApi.item.get_item_quote_history(this.itemId)  // only gets subset of fields
                .then(response => {
                    //this.lineItemBids = cloneDeep(response.data);
                    this.rfxList = response.data.map(rfxData => new Rfx(rfxData));
                    return true;
                })
                .catch(error => {
                    this.handleError(error, 'Error while getting quote history');
                    return false;
                })
                .then(success => {
                    this.loadingList = false;
                    return success;
                });
        },
        formatCurrency: function(value, currCode) {
            return FormatCurrencyHelper(value, currCode);
        },
    }
}
</script>

<style>

</style>